class FeaturedProductsPager extends HTMLElement {
  #controller = new AbortController();
  #breakpoints = [
    { mq: window.matchMedia('(min-width: 1280px)'), perView: 4 },
    { mq: window.matchMedia('(min-width: 1024px)'), perView: 3 },
    { mq: window.matchMedia('(min-width: 768px)'), perView: 2 },
  ];

  connectedCallback() {
    const slideshow = this.querySelector('slideshow-component');
    if (!slideshow) return;

    const getPerView = () => {
      for (const b of this.#breakpoints) {
        if (b.mq.matches) return b.perView;
      }
      return 1;
    };

    const maxIndex = (perView) => {
      const total = slideshow.slides?.length ?? 0;
      return Math.max(0, total - perView);
    };

    Object.defineProperty(slideshow, 'nextIndex', {
      configurable: true,
      get() {
        const perView = getPerView();
        const max = maxIndex(perView);
        if (this.current >= max) return slideshow.slides?.length ?? 0;
        return Math.min(this.current + perView, max);
      },
    });

    Object.defineProperty(slideshow, 'previousIndex', {
      configurable: true,
      get() {
        const perView = getPerView();
        return Math.max(this.current - perView, 0);
      },
    });

    const updateDots = () => {
      const perView = getPerView();
      const max = maxIndex(perView);
      const dots = this.querySelectorAll('.slideshow-controls__dots > li');
      dots.forEach((li, idx) => {
        const isPage = (idx % perView === 0 && idx <= max) || idx === max;
        li.toggleAttribute('hidden', !isPage);
      });
    };

    const refresh = () => {
      updateDots();
      slideshow.current = slideshow.current;
    };

    for (const b of this.#breakpoints) {
      b.mq.addEventListener('change', refresh, { signal: this.#controller.signal });
    }
    requestAnimationFrame(refresh);
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if (!customElements.get('featured-products-pager')) {
  customElements.define('featured-products-pager', FeaturedProductsPager);
}
